<template>
	<div class="partecipants-container" v-show="visible">
		<div class="partecipants-header">
			<span>{{ $t('live_call_participants') }}</span>
			<svg @click="$emit('close')" style="width: 20px; height: 20px" viewBox="0 0 24 24">
				<path fill="white" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
			</svg>
		</div>
		<div class="partecipants-list">
			<div class="partecipants-info" :class="{ show: visible }" v-for="(user, index) in filteredParticipants" :key="'list_' + index">
				<div class="partecipant-personal-info">
					<div class="badge-container">
						<span v-if="!user.isScreenShare" class="badge" :style="{ backgroundColor: user.avatarColor ? user.avatarColor : getRandomColor(user.name) }"
							><span v-if="user.name">{{ user.name.substring(0, 1).toUpperCase() }}</span></span
						>
						<svg v-else viewBox="0 0 24 24" style="width: 25px !important; height: auto">
							<path
								fill="white"
								d="M23 4V16C23 17.11 22.11 18 21 18H15V16H21V4H3V16H9V18H3C1.9 18 1 17.11 1 16V4C1 2.89 1.89 2 3 2H21C22.1 2 23 2.89 23 4M13 13H16L12 9L8 13H11V20H8V22H16V20H13V13Z"
							></path>
						</svg>
					</div>
					<div class="name">{{ user.name }} {{ user.isScreenShare ? ' (presentazione)' : '' }}</div>
				</div>
				<div class="partecipant-status-info">
					<div class="pinned" :class="{ statusEnabled: user.pinned }">
						<span @click="handlePin(user)">
							<svg class="user-pin" viewBox="0 0 24 24">
								<path
									:d="
										user.pinned
											? 'M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12Z'
											: 'M2,5.27L3.28,4L20,20.72L18.73,22L12.8,16.07V22H11.2V16H6V14L8,12V11.27L2,5.27M16,12L18,14V16H17.82L8,6.18V4H7V2H17V4H16V12Z'
									"
								/>
							</svg>
						</span>
					</div>
					<div class="audio" :class="[{ statusEnabled: user.audioEnabled }, { 'hide-screensharing': user.isScreenShare }]">
						<svg v-show="!user.audioEnabled" class="user-audio" viewBox="0 0 24 24">
							<path
								fill="white"
								d="M19,11C19,12.19 18.66,13.3 18.1,14.28L16.87,13.05C17.14,12.43 17.3,11.74 17.3,11H19M15,11.16L9,5.18V5A3,3 0 0,1 12,2A3,3 0 0,1 15,5V11L15,11.16M4.27,3L21,19.73L19.73,21L15.54,16.81C14.77,17.27 13.91,17.58 13,17.72V21H11V17.72C7.72,17.23 5,14.41 5,11H6.7C6.7,14 9.24,16.1 12,16.1C12.81,16.1 13.6,15.91 14.31,15.58L12.65,13.92L12,14A3,3 0 0,1 9,11V10.28L3,4.27L4.27,3Z"
							/>
						</svg>
						<div class="badge" v-show="user.audioEnabled" :class="{ speaking: user.isSpeaking }">
							<div :class="'o4_' + user.id"></div>
							<div :class="'o5_' + user.id"></div>
							<div :class="'o6_' + user.id"></div>
						</div>
					</div>
					<div class="video" :class="[{ statusEnabled: user.videoEnabled }, { 'hide-screensharing': user.isScreenShare }]">
						<svg v-if="!user.videoEnabled && !user.isScreenShare" class="user-video" viewBox="0 0 24 24">
							<path
								fill="white"
								d="M3.27,2L2,3.27L4.73,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16C16.21,18 16.39,17.92 16.54,17.82L19.73,21L21,19.73L3.27,2M21,6.5L17,10.5V7A1,1 0 0,0 16,6H9.82L21,17.18V6.5Z"
							/>
						</svg>
						<svg v-else class="user-video" viewBox="0 0 24 24">
							<path d="M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5Z"></path>
						</svg>
					</div>
					<div class="recording" :class="[(recordOn && user.isLocal) || user.isRecording ? 'on' : 'off', { 'hide-screensharing': user.isScreenShare }]">
						<svg viewBox="0 0 24 24">
							<path
								:d="
									(recordOn && user.isLocal) || user.isRecording
										? 'M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9Z'
										: 'M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z'
								"
							/>
						</svg>
					</div>
				</div>
				<span v-if="filteredParticipants.length > 1" class="line" :class="index % 2 === 0 ? 'line-right' : 'line-left'"></span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'UserList',
	props: {
		participants: {
			type: Array,
			required: true
		},
		visible: {
			type: Boolean,
			default: false
		},
		recordOn: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		filteredParticipants() {
			return this.participants.filter((u) => u.name && u.name !== '')
		}
	},
	methods: {
		getRandomColor(name) {
			if (!name) return '#CCCCCC' // Colore di default se il nome non è valido
			const colors = [
				'#FFC312', // Giallo Oro Vivace
				'#FF8C42', // Arancio Mandarino
				'#E74C3C', // Rosso Rubino
				'#FF6B9D', // Rosa Fucsia Vivido
				'#A55EEA', // Viola Ametista
				'#9B59B6', // Viola Orchidea
				'#4A90E2', // Blu Reale Luminoso
				'#5DADE2', // Azzurro Cielo Elettrico
				'#26C281', // Verde Smeraldo
				'#A3CB38' // Verde Lime Brillante
			]

			// Funzione di hash FNV-1a con gestione corretta degli overflow
			let hash = 2166136261
			for (let i = 0; i < name.length; i++) {
				hash ^= name.charCodeAt(i)
				hash = Math.imul(hash, 16777619) // Moltiplicazione a 32-bit
			}

			// Restituisce il colore corrispondente all'indice calcolato
			return colors[Math.abs(hash) % colors.length]
		},
		handlePin(user) {
			this.$emit('pin', user)
		}
	}
}
</script>

<style lang="scss" scoped>
.partecipants-container {
	box-shadow: 0 3px 6px rgba(255, 255, 255, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
	background: #0c1e3d;
	overflow: hidden;
	flex-direction: column;
	height: 100%;
	display: flex;
	align-content: center;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
	vertical-align: middle;
	flex: 1;
	border-radius: 10px;

	.partecipants-header {
		background: rgba(116, 171, 226, 0.15);
		width: 100%;
		height: 40px;
		font-size: 14px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1px solid hsla(210, 65%, 67%, 0.55);
		color: white;

		span,
		svg {
			cursor: pointer;
			padding: 0 10px;
		}

		svg path {
			fill: white;
		}
	}

	.partecipants-list {
		padding-top: 1rem;
		padding-bottom: 1rem;
		box-sizing: border-box;
		width: 100%;
		flex-direction: column;
		gap: 2px;
		display: flex;
		flex: 1;
		overflow-y: auto;

		.partecipants-info .badge-container svg {
			width: 25px !important;
			height: auto !important;
		}

		.partecipants-info {
			display: flex;
			flex-direction: column;
			align-items: center;
			font-size: 12px;
			border-radius: 8px;
			color: white;
			justify-content: space-between;
			opacity: 0;
			transform: scale(0);
			transition: all 0.2s ease-out;
			transition-delay: 0s;

			&.show {
				transform: scale(1);
				opacity: 1;
				transition: all 0.4s ease-out;
				transition-delay: 0.2s;
			}
			.line {
				margin-top: 0.75rem;
				width: 100%;
				height: 1px;
				background-color: rgba(255, 255, 255, 0.05);
				&.line-left {
					margin-left: 45%;
				}
				&.line-right {
					margin-right: 45%;
				}
			}
			.partecipant-personal-info {
				box-sizing: border-box;
				display: flex;
				align-items: center;
				width: 100%;
				padding: 0.5rem 1rem 0px 1rem;
			}
			.partecipant-status-info {
				box-sizing: border-box;
				padding: 0rem 1rem 0px 1rem;
				display: flex;
				align-items: center;
				justify-content: flex-end;
				width: 100%;
				gap: 10px;
				.pinned,
				.audio,
				.video {
					min-width: 35px;
					display: flex;
					justify-content: center;
					align-items: center;
					svg {
						opacity: 0.5;
						width: 24px;
						height: 24px;
						path {
							fill: white;
							transition: all 250ms ease-in-out;
						}
					}
				}

				.recording {
					min-width: 35px;
					display: flex;
					justify-content: center;
					align-items: center;
					svg {
						width: 24px;
						height: 24px;
					}
					&.off {
						svg {
							opacity: 0.5;
							path {
								fill: white;
								transition: all 250ms ease-in-out;
							}
						}
					}
					&.on {
						svg {
							opacity: 1;
							path {
								fill: rgb(255, 69, 69);
								transition: all 250ms ease-in-out;
							}
						}
					}
				}
			}

			div {
				&.pinned {
					cursor: pointer;
				}

				&.name {
					padding: 0 10px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					width: 100%;
					text-align: left;
					font-size: 15px;
				}

				&.recording {
					text-align: right;
				}

				&.audio {
					z-index: 12;

					span {
						display: flex;
						text-align: right;
						justify-content: flex-end;
					}

					span svg {
						margin-left: auto;
						margin-right: 3px;
					}

					.badge {
						margin-left: auto;
						color: white;
					}
				}

				.badge {
					background: #3280d3;
					color: white;
					width: 25px;
					height: 25px;
					display: flex;
					font-size: 15px;
					justify-content: center;
					align-items: center;
					border-radius: 50%;

					[class^='o4_'],
					[class^='o5_'],
					[class^='o6_'] {
						position: relative;
						height: 19%;
						width: 4px;
						background: white;
						margin: 1.5px;
						border-radius: 200px;
						transition: all linear 0.1s;
					}

					&:not(.speaking) {
						[class^='o4_'],
						[class^='o5_'],
						[class^='o6_'] {
							height: 19% !important;
						}
					}
				}
			}
		}
	}

	.hide-screensharing {
		opacity: 0;
		visibility: hidden;
		pointer-events: none;
		* {
			display: none;
		}
	}
	.statusEnabled {
		svg path {
			fill: #01c9fa !important;
		}
	}
}
</style>
